import React from 'react';
import propTypes from 'prop-types';
import {default as Button} from '@sinclair-digital/sbg-storyline-components/src/components/Button';
import classes from './BulkEditControls.scss';

const BulkEditControls = props => {
    const {
        disabled,
        publishAll,
        pullAll,
        toggleTagPanel,
    } = props;

    return (
        <div className={classes.controls}>
            <Button
                displayType="primary"
                onClick={pullAll}
                disabled={disabled}
            >Pull
            </Button>
            <Button
                onClick={publishAll}
                disabled={disabled}
            >
                Publish
            </Button>
            <Button
                onClick={toggleTagPanel}
                disabled={disabled}
            >
                Tags...
            </Button>
        </div>
    );
};


BulkEditControls.propTypes = {
    disabled: propTypes.bool,
    publishAll: propTypes.func,
    toggleTagPanel: propTypes.func,
    pullAll: propTypes.func,
};

export default BulkEditControls;
